import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const t = localStorage.getItem("sq_token");
    if (!t) { setUser(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch { setUser(null); localStorage.removeItem("sq_token"); }
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("sq_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("sq_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const google = async (name, email) => {
    const { data } = await api.post("/auth/google", { name, email });
    localStorage.setItem("sq_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const otpRequest = async (phone) => (await api.post("/auth/otp/request", { phone })).data;
  const otpVerify = async (payload) => {
    const { data } = await api.post("/auth/otp/verify", payload);
    localStorage.setItem("sq_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const updateProfile = async (patch) => {
    const { data } = await api.put("/auth/me", patch);
    setUser(data);
    return data;
  };
  const logout = () => { localStorage.removeItem("sq_token"); setUser(null); };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, google, otpRequest, otpVerify, updateProfile, logout, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
